import React from 'react';

const STEPS = [
  { id: 1, label: 'Personal Details', icon: '👤' },
  { id: 2, label: 'Vehicle Info', icon: '🚗' },
  { id: 3, label: 'Documents', icon: '📄' },
  { id: 4, label: 'ID Verify', icon: '🔍' },
  { id: 5, label: 'Background', icon: '✅' },
  { id: 6, label: 'Insurance', icon: '🛡️' },
  { id: 7, label: 'Submit', icon: '🎉' },
];

const StepProgressBar = ({ currentStep }) => {
  return (
    <div className="w-full px-4 py-6">
      {/* Desktop */}
      <div className="hidden md:flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200 z-0">
          <div
            className="h-full transition-all duration-500"
            style={{
              width: `${((currentStep - 1) / (STEPS?.length - 1)) * 100}%`,
              background: 'linear-gradient(90deg, #ffd700, #f59e0b)',
            }}
          />
        </div>
        {STEPS?.map((step) => {
          const isCompleted = currentStep > step?.id;
          const isActive = currentStep === step?.id;
          return (
            <div key={step?.id} className="flex flex-col items-center z-10 relative">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 shadow-md"
                style={{
                  background: isCompleted
                    ? 'linear-gradient(135deg, #ffd700, #f59e0b)'
                    : isActive
                    ? '#0a1628' :'#e5e7eb',
                  color: isCompleted ? '#0a1628' : isActive ? '#ffd700' : '#9ca3af',
                  border: isActive ? '2px solid #ffd700' : 'none',
                  transform: isActive ? 'scale(1.15)' : 'scale(1)',
                }}
              >
                {isCompleted ? '✓' : step?.id}
              </div>
              <span
                className="mt-2 text-xs font-medium text-center max-w-16 leading-tight"
                style={{ color: isActive ? '#0a1628' : isCompleted ? '#f59e0b' : '#9ca3af' }}
              >
                {step?.label}
              </span>
            </div>
          );
        })}
      </div>
      {/* Mobile */}
      <div className="flex md:hidden items-center gap-3">
        <div className="flex gap-1 flex-1">
          {STEPS?.map((step) => (
            <div
              key={step?.id}
              className="h-1.5 flex-1 rounded-full transition-all duration-300"
              style={{
                background:
                  currentStep > step?.id
                    ? 'linear-gradient(90deg, #ffd700, #f59e0b)'
                    : currentStep === step?.id
                    ? '#0a1628' :'#e5e7eb',
              }}
            />
          ))}
        </div>
        <span className="text-sm font-semibold text-gray-600 whitespace-nowrap">
          {currentStep}/{STEPS?.length}
        </span>
      </div>
      <div className="flex md:hidden mt-2">
        <span className="text-sm font-bold" style={{ color: '#0a1628' }}>
          Step {currentStep}: {STEPS?.[currentStep - 1]?.label}
        </span>
      </div>
    </div>
  );
};

export default StepProgressBar;
